export default "__VITE_ASSET__LCdIK00___"